<template>
  <div class="w-100 multi-select-table">
    <b-table
      ref="multiSelectTable"
      selectable
      select-mode="multi"
      :items="assessmentSymptoms"
      :fields="fields"
      @row-selected="onRowSelected"
      :bordered="true"
      responsive="sm"
    >
      <template v-slot:head(id)="data">
        <b-form-checkbox
          :disabled="actionType === 'View'"
          :checked="assessmentSymptoms.length === selectedAssessments.length"
          @change="selectAndDeselectAllRows($event)"
        >
          Select All
        </b-form-checkbox>
      </template>

      <template v-slot:cell(id)="data">
        {{
          selectedSymptomIds &&
          selectedSymptomIds.includes(data.item.id) &&
          (actionType === "Edit" || actionType === "View") &&
          !isTableRendered
            ? onSelectRowByIndex(data.index)
            : ""
        }}
        <b-form-checkbox
          :checked="data.rowSelected"
          @change="onSelectAndDeselectRowByIndex(data.index, $event)"
          :disabled="actionType === 'View'"
        ></b-form-checkbox>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import actions from "@/constants/_actions";

export default {
  name: "MultiSelectTable",
  data() {
    return {
      selectedAssessments: [],
      selectedSymptomIds: [],
      isTableRendered: false,
      fields: [
        { key: "id", label: "SelectAll" },
        { key: "name", label: "Options" }
      ]
    };
  },
  props: {
    actionType: {
      type: String
    },
    selectedSymptoms: {
      type: Array
    }
  },
  computed: {
    ...mapGetters({
      assessmentSymptoms: "assessments/getAssessmentSymptoms"
    })
  },
  beforeMount() {
    if (this.actionType === actions.EDIT || this.actionType === actions.VIEW) {
      this.selectedSymptomIds =
        this.selectedSymptoms &&
        this.selectedSymptoms.map(item => {
          return item.assessment_symptom_id;
        });
    }
  },
  methods: {
    onRowSelected(items) {
      this.isTableRendered = true;
      this.$emit("selectedItems", items);
      this.selectedAssessments = items;
    },

    selectAndDeselectAllRows(checked) {
      if (checked) {
        this.$refs.multiSelectTable.selectAllRows();
      } else {
        this.$refs.multiSelectTable.clearSelected();
      }
    },

    onSelectAndDeselectRowByIndex(index, checked) {
      if (checked) {
        this.$refs.multiSelectTable.selectRow(index);
      } else {
        this.$refs.multiSelectTable.unselectRow(index);
      }
    },

    onSelectRowByIndex(index) {
      if (this.$refs.multiSelectTable) {
        this.$refs.multiSelectTable.selectRow(index);
      }
    },

    unselectAllRows() {
      this.$refs.multiSelectTable.clearSelected();
      this.isTableRendered = false;
    }
  }
};
</script>
